// AddressContext.js
import React, { useState } from 'react';

const AddressValueContext = React.createContext({
    searchAddress: '',
    nameCardAddress: '',
});

const AddressValueProvider = ({ children }) => {
    const [searchAddress, setSearchAddress] = useState('');
    const [nameCardAddress, setNameCardAddress] = useState('');

    return (
        <AddressValueContext.Provider value={{ searchAddress, setSearchAddress, nameCardAddress, setNameCardAddress }}>
            {children}
        </AddressValueContext.Provider>
    );
};

export { AddressValueContext, AddressValueProvider };